import type { SponsoredBoard, SponsoredTile } from '@talkofthetown/shared';
import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { config } from '../config';
import { db } from '../firebase';

const NONE: SponsoredTile[] = [];

/**
 * The running promotions (`sponsored/board`, one small public document), live. Not read at all
 * while paid posts are off (then it's loaded, and empty, from the start).
 */
export function useSponsored(): { tiles: SponsoredTile[]; loaded: boolean } {
  const [state, setState] = useState({ tiles: NONE, loaded: !config.payments });
  useEffect(() => {
    if (!config.payments) return;
    return onSnapshot(
      doc(db, 'sponsored', 'board'),
      (snap) =>
        setState({
          tiles: (snap.data() as SponsoredBoard | undefined)?.tiles ?? NONE,
          loaded: true,
        }),
      (err) => {
        console.warn('Sponsored posts unavailable', err);
        setState({ tiles: NONE, loaded: true });
      },
    );
  }, []);
  return state;
}
